import * as T from './rootDetectionTypes';

interface RootDetectionState {
  isHighRisk: boolean | null; // null = pending, true = rooted, false = safe
  loading: boolean;
  error: string | null;
}

const initialState: RootDetectionState = {
  isHighRisk: null,
  loading: false,
  error: null,
};

type RootDetectionAction =
  | { type: typeof T.CHECK_ROOT_DETECTION_REQUEST }
  | { type: typeof T.CHECK_ROOT_DETECTION_SUCCESS; payload: boolean }
  | { type: typeof T.CHECK_ROOT_DETECTION_FAILURE; payload: string };

export const rootDetectionReducer = (
  state: RootDetectionState = initialState,
  action: RootDetectionAction
): RootDetectionState => {
  switch (action.type) {
    case T.CHECK_ROOT_DETECTION_REQUEST:
      return { ...state, loading: true, error: null };
    case T.CHECK_ROOT_DETECTION_SUCCESS:
      return { isHighRisk: action.payload, loading: false, error: null };
    case T.CHECK_ROOT_DETECTION_FAILURE:
      // On detection failure, fail open — do not block the app
      return { isHighRisk: false, loading: false, error: action.payload };
    default:
      return state;
  }
};
